<template>
  <div class="assign-program-page shadow-sm bg-light">
    <div class="top-container">
    <b-row class="top-section">
      <b-col md="3" sm="12" class="d-flex justify-content-center justify-content-md-start">
        <div class="return-back text-center text-md-left" @click="close"><u>{{form.editMode ? 'Close' : 'Clear'}}</u></div>
      </b-col>
      <b-col md="6" sm="12" class="d-flex justify-content-center">
        <div class="top-title">{{ (form.editMode ? 'Edit ' : 'New ') + name }}</div>
      </b-col>
      <b-col md="3" sm="12" class="d-flex justify-content-center justify-content-md-end">
        <!-- <b-button class="save-btn" type="submit" variant="primary" @click="addExercises">ADD EXERCISES</b-button> -->
        <b-button :disabled="disableSubmit" class="save-btn" type="submit" variant="primary" @click="askConfirmation">{{ form.editMode ? 'Update' : 'Assign'}}</b-button>
      </b-col>
    </b-row>
    <hr class="horizontal-line"/>
    <div>
      <b-row class="first-section mt-4">
        <b-col md="6" sm="12">
          <b-form-group id="select-individual-user"
                        label-for="assign-individual-user-input">
            <div class="input-label">Choose User</div>
            <Multiselect
                id="assign-individual-user-input"
                v-model="form.selectedUsers"
                :delay="500"
                :hide-selected="true"
                :internal-search="false"
                :loading="fetchingUsers"
                :multiple="true"
                :options="foundUsers"
                :searchable="true"
                :disabled="form.editMode"
                label="email"
                mode="tags"
                placeholder=""
                trackBy="user_id"
                @open="searchUsers('')"
                @search-change="searchUsers"
            ></Multiselect>
            <b-icon-caret-down-fill class="icon-drop" />
          </b-form-group>
        </b-col>
        <b-col md="6" sm="12">
          <b-form-group id="selected-program-type" lavel-for="selected-program-type-radio">
            <div class="input-label">{{ name }} type</div>
            <!-- <b-form-group
              v-slot="{ ariaDescribedby }"
              class="m-0"
            >
            <b-form-radio-group
              id="selected-program-type-radio"
              v-model="form.programType"
              class="form-radio"
              :options="programTypes"
              :aria-describedby="ariaDescribedby"
              button-variant="outline-primary"
              text-field="label"
              @input="radioClicked()"
              value-field="value"
              buttons
            ></b-form-radio-group>
    </b-form-group> -->
            <fieldset data-v-46a0e7e5="" class="form-group radio-group m-0" id="__BVID__31">
              <label :class="{'active': form.programType !== 'weekly'}" @clicked="() => {buttonClicked(programTypes[0].label, e)}">
                <input id="selected-program-type-radio_BV_option_0" type="radio" v-model="form.programType" name="selected-program-type-radio" checked class="" value="daily">
                <span>{{programTypes[0].label}}</span>
              </label>
              <label :class="{'active': form.programType === 'weekly'}">
                <input id="selected-program-type-radio_BV_option_1" type="radio" v-model="form.programType" name="selected-program-type-radio" value="weekly">
                <span>{{programTypes[1].label}}</span>
              </label>
            </fieldset>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="second-section">
        <b-col md="6" sm="12">
          <b-form-group
              id="input-group-2"
              label-for="input-2">
            <div class="input-label">Start Date</div>
            <b-form-input
                id="input-2"
                v-model="form.startDate"
                placeholder="Select Start Date"
                required
                type="date"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6" sm="12">
          <!--          <b-form-group-->
          <!--              id="input-group-3"-->
          <!--              label-for="input-3">-->
          <!--            <div class="input-label">Duration</div>-->
          <!--            <multiselect-->
          <!--                id="input-3"-->
          <!--                v-model="duration"-->
          <!--                :allow-empty="false"-->
          <!--                :options="durationOptions"-->
          <!--                class="bg-light rounded"-->
          <!--                label="name"-->
          <!--                placeholder="Select Duration"-->
          <!--                trackBy="id">-->
          <!--            </multiselect>-->
          <!--          </b-form-group>-->
          <b-form-group
              id="input-group-3"
              label-for="input-3">
            <div class="input-label">End Date</div>
            <b-form-input
                id="input-3"
                v-model="form.endDate"
                placeholder="Select End Date"
                required
                type="date"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="third-section">
        <b-col>
          <b-form-group
              id="input-group-program-name"
              label-for="input-program-name">
            <div class="input-label">Program Name</div>
            <b-form-input
                id="input-program-name"
                v-model="form.programName"
                required
                maxLength="250"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="fourth-section">
        <b-col>
          <div class="input-label">Set Parameters</div>
          <div class="videos-parameters">
            <template v-if="form.programType === 'weekly'">
              <draggable v-model="selectedVideosList" group="videos">
                <b-row v-for="(video, vidx) of selectedVideosList" class="video-parameters m-0 mb-3 shadow-sm">
                <b-col md="4" sm="12" class="p-0">
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="selected-video-container p-0">
                      <div class="remove-video">
                        <b-icon class="cursor-pointer" font-scale="1.5" icon="x-circle"
                                @click="removeVideo(vidx)"></b-icon>
                      </div>
                      <div ref="thumbnail" class="video-thumbnail rounded d-flex align-items-center">
                        <div class="previewContainer">
                          <img
                              v-if="video.thumbnail !== null"
                              :src="video.thumbnail"
                              alt=""
                              class="rounded img-fluid"
                              height="100%"
                              width="100%"
                          />
                          <img
                              v-else
                              src='../../assets/images/video-placeholder.png'
                              alt=""
                              class="rounded img-fluid"
                              height="100%"
                              width="100%"
                          />
                        </div>
                        <div v-if="video.duration" class="video-duration">
                          {{ video.duration | videoDuration }}
                        </div>
                      </div>
                      <div
                          v-b-tooltip.hover
                          :title="video.title"
                          boundary-padding="2"
                          class="video-title mt-2 ef-cursor-pointer workout-link"
                          to="#">
                        <b class="title-line-limit">{{ video.title }}</b>
                      </div>
                      <div class="reps-sets-container" v-if="video.repetitionConfig">
                        <!-- <div class="d-flex" v-if="video.repetitionConfig.repetitions">
                          <b-form-spinbutton id="reps-inline" v-model="video.repetitionConfig.repetitions" class="border-primary text-primary shadow-sm bg-light" min="0" size="sm" inline></b-form-spinbutton>
                          <label for="reps-inline">Reps</label>
                        </div> -->
                        <div class="reps-container" >
                          <!-- <b-form-select  id="reps-inline" v-model="video.repetitionConfig.duration" :options="timeOptions" class="border-primary text-primary shadow-sm bg-light time-dropdown"  size="sm" inline></b-form-select> -->
                          <label for="reps-inline" class="mb-0 time-set-input-label">min</label>
                          <b-form-input
                              id="duration-input"
                              v-model="video.repetitionConfig.duration"
                              type="string"
                              placeholder="mm:ss"
                              v-mask="'##:##'"
                              class="time-set-input border-primary text-primary shadow-sm bg-light time-input mr-1"
                              size="sm"
                              :min="0"
                              inline
                          ></b-form-input>
                        </div>
                        <div class="sets-container" v-if="video.repetitionConfig.sets">
                          <label for="reps-inline" class="mb-0 time-set-input-label">Sets</label>
                          <b-form-spinbutton id="reps-inline" v-model="video.repetitionConfig.sets" min="1" class="notranslate time-set-input border-primary text-primary shadow-sm bg-light" size="sm" inline></b-form-spinbutton>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>
                <b-col md="8" sm="12" class="p-0">
                  <div class="selected-video-config">
                    <div v-for="(week, widx) of video.schedule" class="week-schedule">
                      <div class="week-label">Week {{ widx + 1 }}</div>
                      <div class="week-days">
                        <div v-for="(day, i) of ['M', 'T', 'W', 'T', 'F', 'S', 'S']"
                             :style="{backgroundColor: week.includes(i) ? '#8DC63F':'#ffffff'}"
                             class="week-day"
                             @click="toggleDay(vidx, widx, i)"
                        >
                          <span class="text-center">{{ day }}</span>
                        </div>
                        <div class="action-buttons">
                          <b-icon class="copy-previous" @click="repeatWeek(vidx, widx)" icon="files" scale="1"></b-icon>
                          <b-icon v-if="widx > 0" class="remove-week" @click="removeWeekFromVideo(vidx, widx)" icon="x" scale="1"></b-icon>
                        </div>
                      </div>
                    </div>
                    <div class="add-week" @click="addWeakToVideo(vidx)">
                      <b-icon icon="plus-circle" scale="1.8"></b-icon>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <div class="add-excercise-card">
                <button class="save-btn2" type="submit" @click="addExercises"><b-icon-plus class="mb-1"></b-icon-plus><br /></button>
              </div>
              </draggable>             
            </template>
            <template v-else>

    <draggable v-model="selectedVideosList" group="videos" class="d-flex flex-wrap">

        <b-col v-for="(video, vidx) in selectedVideosList" :key="vidx" class="p-0 pb-3 pr-3" sm="12" md="4">
          <div class="selected-video-container shadow-sm" style="border: 2px solid #d3d3d3">
            <div class="remove-video">
              <b-icon class="cursor-pointer" font-scale="1.5" icon="x-circle" @click="removeVideo(vidx)"></b-icon>
            </div>
            <div ref="thumbnail" class="video-thumbnail rounded d-flex align-items-center">
              <div class="previewContainer">
                <img
                  v-if="video.thumbnail !== null"
                  :src="video.thumbnail"
                  alt=""
                  class="rounded img-fluid"
                  height="100%"
                  width="100%"
                />
                <img
                  v-else
                  src='../../assets/images/video-placeholder.png'
                  alt=""
                  class="rounded img-fluid"
                  height="100%"
                  width="100%"
                />
              </div>
              <div v-if="video.duration" class="video-duration">
                {{ video.duration | videoDuration }}
              </div>
            </div>
            <div
              v-b-tooltip.hover
              :title="video.title"
              boundary-padding="2"
              class="video-title mt-2 ef-cursor-pointer workout-link"
              to="#">
              <b class="title-line-limit">{{ video.title }}</b>
            </div>
            <div class="reps-sets-container" v-if="video.repetitionConfig">
                      <!-- <div class="d-flex" v-if="video.repetitionConfig.repetitions">
                        <b-form-spinbutton id="reps-inline" v-model="video.repetitionConfig.repetitions" class="border-primary text-primary shadow-sm bg-light" min="1" size="sm" inline></b-form-spinbutton>
                        <label for="reps-inline">Reps</label>
                      </div> -->
              <div class="reps-container">
                        <!-- <b-form-select  id="reps-inline" v-model="video.repetitionConfig.duration" :options="timeOptions" class="border-primary text-primary shadow-sm bg-light time-dropdown"  size="sm" inline></b-form-select> -->
                <label for="reps-inline" class="mb-0 time-set-input-label">min</label>
                <b-form-input
                  id="duration-input"
                  v-model="video.repetitionConfig.duration"
                  type="string"
                  placeholder="mm:ss"
                  v-mask="'##:##'"
                  class="time-set-input border-primary text-primary shadow-sm bg-light time-input mr-1"
                  size="sm"
                  :min="0"
                  inline
                ></b-form-input>
              </div>
              <div class="sets-container" v-if="video.repetitionConfig.sets">
                <label for="reps-inline" class="mb-0 time-set-input-label">Sets</label>
                <b-form-spinbutton id="reps-inline" v-model="video.repetitionConfig.sets" min="1" class="notranslate time-set-input border-primary text-primary shadow-sm bg-light" size="sm" inline></b-form-spinbutton>
              </div>
              
            </div>
          </div>
        </b-col>
        <b-col class="p-0 pb-3 pr-3" sm="12" md="4">
      <div class="add-excercise-card" >
        <button class="save-btn2" type="submit" @click="addExercises"><b-icon-plus class="mb-1"></b-icon-plus><br /></button>
      </div>
    </b-col>
    </draggable>
</template>
          </div>
        </b-col>
      </b-row>

    </div>
    <loader v-if="isLoading"></loader>
  </div>
  <div class="assign-count-button cursor-pointer" @click="askConfirmation" v-if="selectedVideos.length">
      <div>ASSIGN</div>
    </div>
  </div>


</template>
<script>
import {programService} from "@/module_dashboard/api/program";
import Multiselect from 'vue-multiselect';
import {createNamespacedHelpers} from "vuex";
import { VueMaskDirective } from 'v-mask';
import draggable from 'vuedraggable';

const {
  mapGetters: mapLayoutGetters,
  mapMutations: mapLayoutMutations,
} = createNamespacedHelpers("dashboard/layout");
const {
  mapGetters: mapThemeGetters
} = createNamespacedHelpers("themes");

function debounce(func, delay) {
  let timeoutId;

  return function (...args) {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

export default {
  components: {
    Multiselect,
    draggable
  },
  directives: {
    mask: VueMaskDirective
  },
  filters: {
    videoDuration: function (time) {
      // Hours, minutes and seconds
      const hrs = ~~(time / 3600);
      const mins = ~~((time % 3600) / 60);
      const secs = ~~time % 60;

      // Output like "01:01" or "04:03:59" or "123:03:59"
      let ret = "";
      if (hrs > 0) {
        ret += "" + (hrs > 9 ? hrs : "0" + hrs) + ":";
      }
      ret += "" + (mins > 9 ? mins : "0" + mins) + ":";
      ret += "" + (secs > 9 ? secs : "0" + secs);
      return ret;
    },
  },
  watch:{
    selectedVideos(data){
      this.selectedVideosList = data
    }
  },
  data() {
    const programTypes = [
      {label: "Daily", value: 'daily'},
      {label: "Weekly", value: 'weekly'}
    ];
    const timeOptions = [];
    for(let i = 1;i<=5; i++){
      timeOptions.push({text : `${i}:00`, value :i*60})
    }
    return {
      foundUsers: [],
      fetchingUsers: false,
      programTypes: programTypes,
      isChallenge: true,
      timeOptions : timeOptions,

      form: {
        id: null,
        selectedUsers: [],
        programType: "daily",
        startDate: null,
        endDate: null,
        programName: null,
        editMode: false
      },
      selectedVideosList : this.selectedVideos,
      isLoading: false,
      noVideoAdded: false,
      validationError: null,
      defaultSchedule: [0, 1, 2, 3, 4, 5, 6], // every day
      screen: 0
    }
  },
  computed: {
    ...mapThemeGetters(["theme", "pages"]),
    ...mapLayoutGetters(["selectedVideos", "createAssignForm"]),
    disableSubmit() {
      return this.isLoading;
    },
    name() {
      return this.isChallenge
          ? this.theme[this.pages.SMB_CHALLENGES].name
          : this.theme[this.pages.SMB_PROGRAMS].name;
    },
    prevRoutePath() {
      return this.form.returnTo ?? (this.prevRoute ? this.prevRoute.fullPath : '/management/video/library');
    },
    payload() {
      let data = {
        startDate: this.form.startDate,
        endDate: this.form.endDate,
        type: this.form.programType,
        userIds: this.form.selectedUsers.map(user => user.user_id),
        name: this.form.programName,
        videos: this.selectedVideosList?.map(v => {
          const video = {id: v.id};
          if (this.form.programType === 'weekly') {
            video.schedule = v.schedule;
          }
          if (v.repetitionConfig) {
            video.repetitionConfig = {};
            const {repetitions, sets, duration} = v.repetitionConfig;
            if (repetitions) video.repetitionConfig.repetition = repetitions;
            if (sets) video.repetitionConfig.sets = sets;
            if(duration) video.repetitionConfig.duration = this.formatDurationToSeconds(duration);
          }
          return video;
        })
      };
      if (this.form.id) data.id = this.form.id;
      return data;
    },
  },
  methods: {
    ...mapLayoutMutations(["setSelectedVideos", "setCreateAssignForm"]),
    makeToast(variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: true
      });
    },
    resetAssignmentForm() {
      this.form = {
        ...this.form,
        id: null,
        selectedUsers: [],
        programType: "daily",
        startDate: null,
        endDate: null,
        programName: null,
        editMode: false
      };
      this.setSelectedVideos([]);
    },
    searchUsers(searchKeyword) {
      this.fetchingUsers = true;
      programService.findUsers({
        limit: 10,
        search: searchKeyword
      }, this.isChallenge)
          .then(users => {
            this.foundUsers = users;
          }).finally(_ => {
        this.fetchingUsers = false;
      });
    },
    isValid(payload) {
      const {name, startDate, endDate, userIds, videos} = payload;
      let error = '';
      if (!name)
        error = 'Program name cannot be blank'
      else if (!startDate)
        error = "Start Date cannot be blank";
      else if (!endDate)
        error = "End Date cannot be blank";
      else if (!Array.isArray(userIds) || !userIds.length)
        error = "Mention user to assign";
      else if (!Array.isArray(videos) || !videos.length) {
        error = "Select atleast one video";
      } else if (this.form.programType === 'weekly') {
        // check schedule pattern is selected for atleast one week.
        const hasRep = videos
            .every(video => {
              const rep = video?.schedule;
              return Array.isArray(rep) && rep.length > 0 &&
                  Array.isArray(rep[0]) && rep[0].length > 0;
            });
        if (!hasRep) error = "Select week schedule in each video for atleast one week";
      }

      if (error) {
        this.makeToast('danger', 'Error', error);
        return false;
      }
      return true;
    },
    submit() {
      this.isLoading = true;
      const data = this.payload;
      programService.createOrUpdateAndAssignTreatment(data).then(res => {
        this.$swal.fire({
          title: `${data.name}`,
          text: `Treatment plan ${this.form.editMode ? 'updated' : 'assigned'} successfully`,
          icon: 'success',
          showConfirmButton: false,
          showCancelButton: true,
          cancelButtonText: 'Ok',
          cancelButtonColor: '#73bc44',
          timer: 3000,
        });
        this.close();
        return res;
      }).catch(error => {
        this.makeToast('danger', 'Error', `Failed to assign ${data.name}`);
      }).finally(_ => this.isLoading = false);
    },
    askConfirmation(){
      if (!this.isValid(this.payload)) return;
      this.$swal.fire({
        title: "Do you want to save the changes?",
         showDenyButton: true,
          confirmButtonText: "Yes",
          denyButtonText: `No`
      }).then((result)=>{
        if (result.isConfirmed) {
          this.submit()
        }
      })
    },

    formatDurationFromSeconds(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    },

    formatDurationToSeconds(duration) {
      const [minutes, seconds] = duration.split(':').map(Number);
      return minutes * 60 + seconds;
    },
    loadTreatmentPlan(id) {
      this.isLoading = true;
      return programService.treatmentPlanForEdit(id).then(plan => {
        let {videos, users, id, name, type, showGroupView, startDate, endDate} = plan;
        users = users.map(user => {
          return {
            email: user.email,
            user_id: user.userId
          }
        });
        videos = videos.map(video => {
          const {id, workoutTypeId, title, thumbnail, duration, workoutDuration, schedule, repetition, sets, restTimeSec} = video;
          return {
            id, title, duration, thumbnail, schedule,
            repetitionConfig: {
              repetitions: repetition,
              sets,
              duration:  this.formatDurationFromSeconds(workoutDuration || 60)
            }
          }
        });
        this.form = {
          ...this.form,
          id,
          selectedUsers: users,
          programType: type,
          startDate,
          endDate,
          programName: name
        }

        this.setCreateAssignForm({...this.form, selectedVideos: videos});
      }).catch(error => {
        this.makeToast('danger', 'Error', `Failed to get treatment plan`);
      }).finally(_ => this.isLoading = false);
    },
    addExercises() {
      this.$router.push({
        path: "/management/video/library",
        query: {
          selectVideo: true
        }
      });
    },
    repeatWeek(videoIndex, weekIndex) {
      const videos = [...this.selectedVideos];
      let video = {...videos[videoIndex]};
      const schedule = [...video.schedule];
      const prevWeek = schedule[weekIndex];

      schedule.splice(weekIndex, 0, prevWeek);

      video = Object.assign({}, this.selectedVideos[videoIndex], {schedule});
      videos.splice(videoIndex, 1, video);
      this.setSelectedVideos(videos);
    },
    toggleDay(videoIndex, weekIndex, dayIndex) {
      const videos = [...this.selectedVideos];
      let video = {...videos[videoIndex]};
      const schedule = [...video.schedule];
      const weekRep = [...schedule[weekIndex]];
      const i = weekRep.findIndex(di => di === dayIndex);
      if (i > -1) weekRep.splice(i, 1);
      else weekRep.push(dayIndex);

      schedule[weekIndex] = weekRep;
      video.schedule = schedule;
      videos[videoIndex] = video;
      this.setSelectedVideos(videos);
    },
    addWeakToVideo(videoIndex) {
      const videos = [...this.selectedVideos];
      let video = {...videos[videoIndex]};
      const schedule = [...video.schedule];
      schedule.push([]);

      video.schedule = schedule;
      videos[videoIndex] = video;
      this.setSelectedVideos(videos);
    },
    removeWeekFromVideo(videoIndex, weekIndex) {
      const videos = [...this.selectedVideos];
      let video = {...videos[videoIndex]};
      const schedule = [...video.schedule];
      schedule.splice(weekIndex, 1);

      video.schedule = schedule;
      videos[videoIndex] = video;
      this.setSelectedVideos(videos);
    },
    removeVideo(vidx) {
      const videos = [...this.selectedVideos];
      videos.splice(vidx, 1);
      this.setSelectedVideos(videos);
    },
    close() {
      this.resetAssignmentForm();
      this.$router.push(this.prevRoutePath);
    },
    Resize() {
      this.screen = window.innerWidth
    },
    buttonClicked(e) {
      console.log(e)
    }
  },
  async mounted() {
    const query = this.$route.query;

    this.isChallenge = query.isChallenge
        ? (query.isChallenge === 'true' || query.isChallenge === true) : false;
    const treatmentPlanId = this.$route.params.id;
    if (treatmentPlanId) {
      this.form.editMode = true;
      await this.loadTreatmentPlan(treatmentPlanId);
    }

    let videos = this.selectedVideos.map(video => {
      let repetitions = video.repetitionConfig?.repetitions;
      let sets = video.repetitionConfig?.sets;
      let duration = (typeof video.repetitionConfig?.duration === 'number' || video.repetitionConfig?.duration === undefined) ? this.formatDurationFromSeconds(video.repetitionConfig?.duration || 60) : video.repetitionConfig?.duration;
      let workout_type_id = video.workout_type_id
      repetitions = repetitions || workout_type_id === 3 ? Math.max(1, repetitions || 0) : undefined;
      sets = sets ?  Math.max(1, sets) : 1;
      return {
        id: video.id,
        title: video.title,
        duration: video.duration,
        thumbnail: video.thumbnail,
        schedule: video.schedule || [this.defaultSchedule],
        repetitionConfig: {
          repetitions,
          sets,
          duration
        },
      }
    });
    this.setSelectedVideos(videos);
    this.form = JSON.parse(JSON.stringify(this.createAssignForm));

    // Setting css through js
    const selectUsersElement = document.querySelector("#select-individual-user");
    if(selectUsersElement){
      selectUsersElement.querySelector(".multiselect__tags").style.cssText = 'border: none; min-height: 55px !important; padding: 10px; display: flex; align-items: center; justify-content: start;';
    }   
    this.screen = window.innerWidth
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    this.setCreateAssignForm({
      ...this.form,
      selectedVideos: this.selectedVideos
    });
    next();
  },
  created() {
    window.addEventListener("resize", this.Resize);
  },
}
</script>
<style lang="scss" scoped>

.assign-count-button {
  position: fixed;
  bottom: 150px;
  right: 16px;
  z-index: 1;

  padding: 8px 24px;
  background: #73bc44;
  border-radius: 25px;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  color: #ffffff;
  text-align: center;
  border: 0;
  max-width: 400px;
  white-space: nowrap;

  display: flex;
  column-gap: 16px;
  align-items: center;

  .selected-count {
    width: 28px;
    height: 28px;
    font-size: 16px;
    padding: 2px;
    border-radius: 50%;
    border: 2px solid white;
    transition: all 0.3s ease;
  }
}

.top-section {
  display: flex;
  justify-content: center;
  padding: 10px 0px;
  row-gap: 16px;
}
.horizontal-line {
  margin-top: 0;
  border-top: 2px solid #969b93;
}

.first-section, .second-section, .third-section {
  .form-control {
    background: #ffffff;
    border: 2px solid #141513;
    box-sizing: border-box;
    border-radius: 5px;
    height: 56px;
    color: #141513;
    position: relative;
    // border: 2px solid #969b92;
  }

  ::v-deep .multiselect__select, .multiselect__tag-icon {
    display: none;
  }

  ::v-deep .multiselect {
    background: #ffffff;
    border: 2px solid #141513;
    box-sizing: border-box;
    border-radius: 5px;
    min-height: 56px;
    color: #141513;
  }
}

.input-label {
  color: #969b92;
  left: 3%;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 8px;
  white-space: nowrap;
}

.return-back {
  height: 24px;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  white-space: nowrap;
  color: #585757;
  padding-top: calc((40px - 24px) / 2 );
}

.top-title {
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  padding-top: 2px;
  margin: 0;
}

.videos-parameters {
  display: flex;
  flex-direction: column;

  .daily-type-videos {
    //gap: 16px;
    //padding: 16px 0;
    //margin-bottom: 16px;
  }

  .video-parameters {
    border: 2px solid #d3d3d3;
    border-radius: 10px;
    padding: 16px 16px;
    row-gap: 32px;
  }

  .selected-video-config {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    overflow-y: auto;

    .week-schedule {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      row-gap: 4px;

      .week-label {
        padding: 0 16px;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        white-space: nowrap;
        color: #969b92;
        min-width: 138px;
      }

      .week-days {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        padding: 0 16px;

        .week-day {
          width: 40px;
          height: 40px;
          border: 1px solid black;
          border-radius: 50%;
          font-weight: 700;
          font-size: 20px;
          line-height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }

        .action-buttons {
          display: flex;
          flex-direction: column;
          row-gap: 6px;
          justify-content: center;
          align-items: center;

          .copy-previous {
            font-size: 14px;
            cursor: pointer;
          }
          .remove-week {
            font-size: 20px;
            cursor: pointer;
          }
        }
      }
    }

    .add-week {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px 0;
      cursor: pointer;

      svg {
        font-size: 18px;
      }
    }
  }
}

.no-video-selected {
  display: flex;
  flex-direction: column;
  padding: 16px 8px;
  padding-left: 24px;
  row-gap: 8px;
  align-items: center;
}

.submit-container {
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: center;
}

.selected-video-container {
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 10px;
  position: relative;

  .remove-video {
    position: absolute;
    margin: 8px;
    left: 0;
    top: 0;
    z-index: 1;
    color: #EF4136;
    width: 24px;
    height: 24px;

    background: white;
    border-radius: 50%;
  }

  .workout-link {
    text-decoration: none;
  }

  .video-thumbnail {
    cursor: pointer;
    position: relative;
    left: 0;
    top: 0;
    overflow: hidden;
    // width: 100%;
    // width: 325px;
    // height: 183px;
    aspect-ratio: 1.79; // width/height : 325/183
  }

  .video-duration {
    position: absolute;
    width: fit-content;
    right: 9px;
    bottom: 9px;
    text-align: center;
    color: #ffffff;
    background-color: #000000c9;
    border-radius: 2px;
    font-size: 13px;
    line-height: 18px;
    font-weight: bold;
    padding: 0 5px;
  }

  .reps-sets-container {
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    column-gap: 14px;
    row-gap: 2px;
    justify-content: space-between;

    .reps-container, .sets-container {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      column-gap: 8px;
    }

    .time-set-input {
      width: 75px !important;
      text-align: center !important;
      font-size: 16px !important;
      height: 25px !important;
    }

    .time-set-input-label{
      color: #969b92;
      font-weight: bold;
      font-size: 16px;
      line-height: 24px;
      text-transform: capitalize;
    }

    ::v-deep .b-form-spinbutton {
      margin-right: 4px;

      .btn {
        padding: 0;
        font-size: 12px;
        color: #73bc44;
      }
      .active {
        color: white !important;
        background-color: #73bc44 !important;
      }
      output {
        width: 18px;
        padding: 0;
      }
      output > bdi {
        min-width: 18px;
        height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    ::v-deep .form-control-sm {
      height: 18px;
      width: 54px;
      border: 1px solid black;
      padding: 1px;
    }

    label {
      font-size: 12px;
      font-height: 18px;
      font-weight: 400;
    }

    .time-dropdown{
      width: 65px;
      height: 20px;
      padding: 0;
      padding-left: 10px 
    }
  }

  .video-title {
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    position: relative;
    font-size: 14px;
    height: 32px;
    line-height: 20px;
    margin-bottom: 16px;
    text-overflow: clip;
    color: #545553;

    .title-line-limit {
      word-break: break-word;
      position: absolute;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* number of lines to show */
      -webkit-box-orient: vertical;
    }
  }
}

.add-excercise-card{
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  position: relative;
  height: 100%;

  .save-btn2{
    height: 100%;
    background-color: transparent;
    border-radius: 10px;
    border: 4px dashed hsla(97, 47%, 50%, 0.5);
    outline: none;
    color: hsla(97, 47%, 50%, 0.5);
    background-color: transparent;

    svg{
      font-size: 10rem;
    }
  }
}

.save-btn {
  padding: 4px 24px;
  background: #73bc44;
  //height: 48px !important;
  //box-shadow: 0px 16px 49px rgba(20, 21, 19, 0.15);
  border-radius: 25px;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  color: #ffffff;
  text-align: center;
  border: 0;
  max-width: 400px;
  white-space: nowrap;
}

::v-deep .bv-no-focus-ring {
  min-height: 56px;
  display: flex;
  align-items: center;

  .custom-radio {
    .custom-control-label::before {
      background-color: #D9D9D9 !important;
      border-radius: 50% !important;
      border: 2px solid black !important;
    }

    .custom-control-input:checked ~ .custom-control-label::after {
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'%3e%3ccircle cx='5' cy='5' r='5' fill='%23000' /%3e%3c/svg%3e") !important;
    }
  }
}

.icon-drop{
  position: absolute;
  right: 29px;
  font-size: 1rem;
  pointer-events: none;
  top: 55px;
}
.card{
  border-radius: .5rem;
}

.add-excercise{
  height: 7rem;
  // border: 2px solid #73BC45;
  // border-radius: 5px;

  .save-btn2{
    color: hsla(97, 47%, 50%, 0.5);
    border-radius: 5px;
    height: calc(100% - 5px);
    width: 100%;
    border: 4px dashed hsla(97, 47%, 50%, 0.5);
    font-size: 2.5rem;
    background-color: transparent;
    transition: .2s ease;
    outline: none;

    svg{
      font-size: 3rem;
    }
  }
}

.radio-group{
  padding: 0 10px;
  border-radius: 5px;
  border: 2px solid black;
  display: flex;
  align-items: center;
  height: 58px;
  justify-content: center;
  gap: 10px;

  label{
    margin: 0;
    color: #a2a2a2;
    //height: 38px;
    line-height: 38px;
    width: calc(50% - 5px);
    border-radius: 5px;
    text-align: center;
    cursor: pointer;
    border-radius: 25px;

    input{
      display: none;
    }

  }

  .active{
    margin: 0;
    color: white;
    background-color: #73bc44;
  }

  
}

.assign-program-page{
    padding: 2rem;
  }

</style>